import IntroCtrl from './intro.controller';
import IntroSteps from './services/steps';
import introLanguageSelector from "./directives/intro-language-select";

/*@ngInject*/
export default angular.module('app.intro', [])
    .controller('IntroCtrl', IntroCtrl)
    .directive('introLanguageSelector', () => new introLanguageSelector)
    .service('IntroSteps', IntroSteps)
    .name;
